import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../index';
import axios from 'utils/axios';
import { ProposalTemplateProps } from 'types/props-obj/ProposalTemplateProps';
const initialState: ProposalTemplateProps = {
    apiEndPoint: "proposal-template",
    isOpen: false,
    pageNumber:1,
    last_page:1,
    pageLimit:10,
    current_page:1,
    total:0,
    list: [],
    item:null,
    error: null,
    alertPopup: false
  };
const proposalTemplate = createSlice({
    name: 'proposalTemplate',
    initialState,
    reducers: {
      
       
  
      hasError(state, action) {
        state.error = action.payload.error;
      },
      setPageNumber(state, action) {
        state.pageNumber = action.payload;
      },
      setPageLimit(state, action) {
        state.pageLimit = action.payload;
      },
      // get all proposalTemplate list
      getList(state, action) {
        state.list.push(action.payload);
        const replaceList = state.list.filter((liste) => liste.id != 0);
        state.list = replaceList;
      },
  
      // get proposalTemplate details
      setProposalTemplate(state, action) {
        state.item = action.payload;
      },
  
      // GET ProposalTemplates
      setProposalTemplatesSuccess(state, action) {
          state.list = action.payload.data;
          state.current_page=action.payload.current_page;
          state.last_page=action.payload.last_page;
          state.total=action.payload.total
      },

    // ADD ProposalTemplate
    addProposalTemplateSuccess(state, action) {
      state.list = [...state.list,action.payload];      
    },

    // EDIT ProposalTemplate
    editProposalTemplateSuccess(state, action) {
      var foundIndex = state.list.findIndex(x => x.id == action.payload.id);
      state.list[foundIndex] = action.payload;
    },

    deleteProposalTemplateSuccess(state, action) {
      const deleteData = state.list.filter((item) => item.id !== action.payload);
      state.list = deleteData;
    },
    deleteAttachmentSuccess(state, action) {
      if(state?.item){
        const deleteData = state?.item?.attachments?.filter((item) => item.id !== action.payload);
        state.item.attachments = deleteData;
      }
    },
    alertPopupToggle(state, action) {
      state.alertPopup = action.payload.alertToggle;
    }
    }
  });
  export default proposalTemplate.reducer;
  export const {    getList,setPageNumber,setPageLimit,alertPopupToggle} = proposalTemplate.actions;

  export function getProposalTemplates(params:any={}) {
    return async () => {
      try {
        const response = await axios.get(initialState.apiEndPoint,{params:params});
        dispatch(proposalTemplate.actions.setProposalTemplatesSuccess(response.data));
      } catch (error) {
        dispatch(proposalTemplate.actions.hasError(error));
      }
    };
  }

  export function getProposalTemplate(id: number | undefined) {
    return async () => {
      try {
        const response = await axios.get([initialState.apiEndPoint,  id].join('/'));
        dispatch(proposalTemplate.actions.setProposalTemplate(response.data));
      } catch (error) {
        dispatch(proposalTemplate.actions.hasError(error));
      }
    };
  }

  export function addProposalTemplate(ls:any) {
    return async () => {
      try {        
        const response = await axios.post(initialState.apiEndPoint, ls,{headers:{'Content-Type': 'multipart/form-data'}});
        dispatch(proposalTemplate.actions.addProposalTemplateSuccess(response.data));
      } catch (error) {
        dispatch(proposalTemplate.actions.hasError(error));
      }
    };
  }
  
  export function editProposalTemplate(id: number | undefined,ls: any) {
    return async () => {
      try {
        const response = await axios.post(initialState.apiEndPoint, {id:id,...ls},{headers:{'Content-Type': 'multipart/form-data'}});
        dispatch(proposalTemplate.actions.editProposalTemplateSuccess(response.data));
      } catch (error) {
        dispatch(proposalTemplate.actions.hasError(error));
      }
    };
  }

  export function deleteProposalTemplate(id: number | undefined) {
    return async () => {
      try {
        await axios.delete([initialState.apiEndPoint,  id].join('/'));
        dispatch(proposalTemplate.actions.deleteProposalTemplateSuccess(id));
      } catch (error) {
        dispatch(proposalTemplate.actions.hasError(error));
      }
    };
  }
  export function deleteAttachement(id: number | undefined) {
    return async () => {
      try {
        await axios.delete('/attachment/'+id);
        dispatch(proposalTemplate.actions.deleteAttachmentSuccess(id));
      } catch (error) {
        dispatch(proposalTemplate.actions.hasError(error));
      }
    };
  }